import React, { useState } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

const SchemaBrowser = ({ tables = [], onColumnClick, searchValue, setSearchValue }) => {
  const [expandedTables, setExpandedTables] = useState({});

  const toggleTable = (tableName) => {
    setExpandedTables((prev) => ({
      ...prev,
      [tableName]: !prev[tableName],
    }));
  };

  const filteredTables = tables.filter((table) =>
    table.table_name.toLowerCase().includes((searchValue || "").toLowerCase())
  );

  const getTypeColor = (type) => {
    if (type.includes("int") || type.includes("numeric") || type.includes("decimal")) {
      return "text-027A48";
    }
    if (type.includes("varchar") || type.includes("text") || type.includes("char")) {
      return "text-primary";
    }
    if (type.includes("timestamp") || type.includes("date") || type.includes("time")) {
      return "text-FFBA08";
    }
    if (type.includes("bool")) {
      return "text-F94B4B";
    }
    return "text-667085";
  };

  return (
    <div className="h-full flex flex-col bg-white border-r border-EAECF0">
      <div className="p-3 border-b border-EAECF0">
        <input
          type="text"
          placeholder="Search tables..."
          value={searchValue || ""}
          onChange={(e) => setSearchValue(e.target.value)}
          className="w-full px-3 py-2 border border-D0D5DD rounded-md text-xs focus:outline-none focus:border-primary"
        />
      </div>
      <div className="flex-1 overflow-y-auto p-2">
        {filteredTables.length === 0 ? (
          <div className="text-xs text-667085 p-2">No tables found</div>
        ) : (
          filteredTables.map((table) => (
            <div key={table.table_name} className="mb-1">
              <button
                onClick={() => toggleTable(table.table_name)}
                className="w-full flex items-center gap-1 px-2 py-1.5 text-xs fw_500 text-344054 hover:bg-f3f8ff rounded"
              >
                {expandedTables[table.table_name] ? (
                  <ChevronDownIcon className="w-3 h-3" />
                ) : (
                  <ChevronRightIcon className="w-3 h-3" />
                )}
                <span className="truncate">{table.table_name}</span>
              </button>
              {expandedTables[table.table_name] && (
                <div className="ml-4 border-l border-EAECF0 pl-2">
                  {table.columns.map((column) => (
                    <button
                      key={column.name}
                      onClick={() => onColumnClick(table.table_name, column.name)}
                      className="w-full flex items-center justify-between px-2 py-1 text-xs text-667085 hover:bg-f3f8ff hover:text-primary rounded"
                    >
                      <span className="truncate">{column.name}</span>
                      <span className={`text-xsm ${getTypeColor(column.type)}`}>
                        {column.type.split(" ")[0]}
                      </span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SchemaBrowser;
